import type { SVGProps } from "react";

import { cn } from "@/lib/utils";

/** Last.fm brand red. */
export const LASTFM_BRAND_COLOR = "#D51007";

type LastfmScrobbleIconProps = SVGProps<SVGSVGElement>;

/**
 * Audioscrobbler-style mark used by Last.fm's API pages for scrobbling.
 * Uses `currentColor`; size via `className`.
 */
export function LastfmScrobbleIcon({ className, ...props }: LastfmScrobbleIconProps) {
  return (
    <svg
      viewBox="0 0 74 40"
      fill="currentColor"
      aria-hidden
      className={cn("h-4 w-7", className)}
      {...props}
    >
      <g transform="translate(0 40) scale(.1 -.1)">
        <path d="M110 378 c-65 -33 -93 -89 -93 -182 0 -98 35 -158 106 -185 52 -20 149 -9 190 22 15 10 16 17 6 45 -6 17 -13 32 -15 32 -2 0 -18 -9 -36 -20 -77 -47 -155 -7 -165 83 -11 93 32 157 104 157 58 0 84 -26 113 -116 44 -132 82 -183 158 -204 90 -25 215 0 241 48 6 12 11 39 11 62 0 52 -38 93 -101 110 -91 23 -94 25 -97 58 -3 27 1 34 23 42 34 13 73 3 86 -21 7 -14 21 -19 50 -19 40 0 41 1 34 27 -4 16 -12 34 -18 42 -18 22 -72 41 -116 41 -107 0 -169 -69 -141 -155 13 -38 56 -67 119 -79 47 -9 81 -32 81 -56 0 -26 -29 -40 -87 -40 -71 0 -106 26 -132 97 -12 32 -28 77 -37 100 -8 23 -25 54 -36 69 -50 63 -167 83 -248 42z" />
      </g>
    </svg>
  );
}
